import React from 'react'
import Icon from '@jarvis.oddle/core/decorators/Icon'
import { IconInterface } from './IconInterface'

// eslint-disable-next-line react/prop-types
const IconNewFulfilledOrder = ({
  className,
  height,
  width,
  fill
}: IconInterface) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox='0 0 101 101'
      fill={fill || 'none'}
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        x='0.936279'
        y='1'
        width='99'
        height='99'
        rx='15.5'
        fill='white'
        stroke='#D6D6D6'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M44.3224 34.4462C44.3224 40.9155 41.9814 46.4961 38.601 49.073L38.639 80.1992C38.64 81.0294 37.9666 81.7025 37.1364 81.7011L32.4053 81.6928C31.5786 81.6913 30.9089 81.0213 30.9079 80.1946L30.8705 49.5534C27.1181 47.2459 24.4502 41.3524 24.4502 34.4462C24.4502 25.5284 28.8987 18.2991 34.3863 18.2991C39.8739 18.2991 44.3224 25.5284 44.3224 34.4462ZM65.8411 18.5907C65.079 18.3994 64.291 18.2991 63.4846 18.2991C62.5372 18.2991 61.6154 18.4375 60.731 18.6992V35.5895H56.3875V21.2241C55.6535 21.9021 54.9822 22.6825 54.3866 23.5487C52.5385 26.2364 51.4193 29.7507 51.4193 33.5964C51.4193 40.6244 55.1574 46.5455 60.2502 48.3378L60.2878 79.0739C60.2888 79.9005 60.9585 80.5706 61.7852 80.572L66.5163 80.5803C67.3464 80.5818 68.0199 79.9087 68.0189 79.0785L67.9807 47.7963C72.4174 45.5359 75.5498 40.03 75.5498 33.5964C75.5498 28.291 73.4197 23.6165 70.1846 20.8726V35.5895H65.8411V18.5907Z'
        fill='url(#paint0_linear_1340:7343)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_1340:7343'
          x1='34.8405'
          y1='30.5568'
          x2='93.6327'
          y2='43.7177'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#0A3040' />
          <stop offset='0.306028' stopColor='#062B58' />
          <stop offset='1' stopColor='#7F50E3' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default Icon(IconNewFulfilledOrder)
